import { Component, ViewChild, AfterViewInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/utils/shared.service';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import * as CommonConstants from '../../utils/common.constants';
import { NumericEditor } from 'src/app/common/grid-utils/numeric-editor.component';

@Component({
  selector: 'app-add-procedure',
  templateUrl: './add-procedure.component.html'
})
export class AddProcedureComponent implements AfterViewInit {

  gridApi: GridApi;
  prList = [];
  rowData = [];
  status;
  @Input() medFileId;
  //add medication 
  colDefs;
  frameworkComponents;
  PARAM_KEY = [CommonConstants.STATUS];
  ptype = [CommonConstants.PARTNER_PRACTITIONER_TYPE,CommonConstants.PARTNER_HOSPITAL_TYPE];
  partnerList = [];
  hospitalList = [];
  MED_PARAM_KEY = [CommonConstants.PROCEDURE_MED_FILE]

  constructor(private modal: NgbModal, private masterService: MasterService, private sharedService: SharedService,
    private medFileService: MedicalFileService, private toastrService: ToastrService) {
    this.frameworkComponents = {
      ngSelectEditor: GridNgSelectDataComponent,
      agDateInput: CustomDateComponent,
      agNumeric:NumericEditor
    }
  }

  ngOnInit() {
    this.masterService.getPartnersByPartnerType(this.ptype);
    this.masterService.partnerList.subscribe(value => {
      this.partnerList = value;
      this.filterPartnerTypes();
    });
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        let masterValues = response['result'];
        this.status = masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
        this.getGrids();
      }
    });
    this.loadProcedure();

  }

  loadProcedure() {
    this.sharedService.medicalFileId$.subscribe(res => {
      this.medFileId = res;
      this.medFileService.getMedicalFilesByKey(this.medFileId, this.MED_PARAM_KEY).subscribe(response => {
        let masterValues = response['result'];
        if (masterValues) {
          this.prList = this.setProcedureList(masterValues[CommonConstants.PROCEDURE_MED_FILE]);
        }
      })
    })
  }

  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }

  filterPartnerTypes() {
    if (this.partnerList && this.partnerList.length==0) {
      this.masterService.getPartnersByPartnerType(this.ptype);
      this.masterService.partnerList.subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    } else {
      this.setPartners();
    }

  }

  setPartners() {
    if (this.partnerList) {
      this.hospitalList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_HOSPITAL_TYPE);
    }
  }

  ngAfterViewInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }
  openGridModal(modalId) {
    this.modal.open(modalId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
  }

  addNewGridRow() {
    const newRow = {
      hospType: '', medprDtDate: '', medprDtPrescription: '', medprNuDurationInDay: '', medmeNuQtyPerTake: '', medprVaName: '',
      medprVaOperator: '', statuCode: ''
    };
    this.rowData.unshift(newRow);
    this.gridApi.setRowData(this.rowData);
  }

  getGrids() {
    this.colDefs = [
      { headerName: 'Prescription Date', field: 'medprDtPrescription', cellEditor: 'agDateInput' },
      { headerName: 'Procedure Date', field: 'medprDtDate', cellEditor: 'agDateInput' },
      { headerName: 'Procedure Name', field: 'medprVaName' },
      { headerName: 'hospiId', field: 'hospiId', hide: true },
      {
        headerName: 'Hospital', field: 'hospital', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.hospitalList, dataColumn: 'hospiId', model: new Parameter(), objectData: ['partnerid', 'partnername'] }
      },
      { headerName: 'Duration in Day', field: 'medprNuDurationInDay' ,cellEditor: 'agNumeric'},
      { headerName: 'Operator', field: 'medprVaOperator' },
      { headerName: 'statuCode', field: 'statuCode', hide: true },
      {
        headerName: 'Status', field: 'status', cellEditor: 'ngSelectEditor',
        cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
      },
    ];

  }

  saveProcedure() {
    this.rowData = this.rowData.map(item => ({
      ...item,
      'medfiId': this.medFileId
    }));
    this.medFileService.saveProcedure(this.rowData).subscribe(res => {
      if (res && res["result"]) {
        this.toastrService.success("Saved Succesffully");
        for(let item of res["result"]){
          this.prList.push(item);
        }
        if (res["result"][0])
          this.prList.unshift(this.setProcedureList(this.setProcedureList(res["result"][0])));
        this.prList = Object.values(this.prList.reduce((acc, c) => (acc[c.medprId] = c, acc), {}));
        this.prList = [...this.prList];
        this.modal.dismissAll();
      }
    })
  }

  onRowSelect(modelId) {
    this.getGrids();
    this.modal.open(modelId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.rowData = this.prList;
  }

  setProcedureList(list) {
    if (list) {
      if (Array.isArray(list)) {
        list = list.map(item => ({
          ...item,
          status: item.statuCode ? this.status.find(obj => +obj.id === +item.statuCode).value : null,
          hospital: item.hospiId ? this.hospitalList.find(obj => +obj.partnerid === +item.hospiId).partnername : null,
        }));
      } else {
        list = {
          ...list,
          status: list['statuCode'] ? this.status.find(obj => +obj.id === +list['statuCode']).value : null,
          hospital: list['hospiId'] ? this.status.find(obj => +obj.partnerid === +list['hospiId']).partnername : null
        }
      }
      return list;
    }
  }
}
